export const layout = {
  brand: {
    logoAlt: 'SkillArea',
  },
  nav: {
    games: 'თამაში',
    privacy: 'კონფიდენციალურობის პოლიტიკა',
    terms: 'გამოყენების პირობები',
  },
  footer: {
    disclaimer:
      'ჩვენი თამაშები, ტურნირები და შეჯიბრებები უნარებზეა ორიენტირებული, არ შეიცავს აზარტული თამაშის მექანიკას და ამიტომ არ ფორმალიზდება აზარტულ თამაშად.',
    sendEmail: 'ელ. ფოსტის გაგზავნა',
    companyName: 'Quantum LLC',
    companyAddress:
      'საქართველო, თბილისი, ნაძალადევის რაიონი, ზღვისუბნის დასასახლება, XI მიკრორაიონი, II კვარტალი, შენობა 38, ბინა 7',
  },
  accountPage: {
    title: 'პროფილი',
    subtitle: 'აქ ნახავ პროფილის ყველა დეტალს',
  },
  header: {
    logout: 'გასვლა',
    aria: {
      loadingBalance: 'ბალანსის ჩატვირთვა',
      logout: 'გასვლა',
      menu: 'მენიუ',
      closeMenu: 'მენიუს დახურვა',
      closeOverlay: 'მენიუს ფონის დახურვა',
    },
    alt: {
      games: 'თამაში',
      balance: 'ბალანსი',
      login: 'შესვლა',
    },
  },
  accountMenu: {
    editProfile: 'პროფილის რედაქტირება',
    balance: 'ბალანსი',
    promocode: 'პრომო კოდი',
    achievements: 'მიღწევები',
    gameHistory: 'თამაშების ისტორია',
  },
  language: {
    ariaLabel: 'ენა',
    en: 'English',
    ka: 'ქართული',
  },
};
